import { BrowserVault, Vault } from '@ionic-enterprise/identity-vault';
import { Capacitor } from '@capacitor/core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class VaultFactory {
  public create(): BrowserVault | Vault {
    return Capacitor.isNativePlatform() ? new Vault() : new BrowserVault();
  }
}
